import './AreaIndicatorItemList.css';

import React from 'react';
import { Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import IndicatorImpact from '../../../b2b-frameworks/components/framework-impact/IndicatorImpact';

const AreaIndicatorItemList = ({ areaIndicator }) => {
    const navigate = useNavigate();
    
    const handleClickOnName = () => {
        navigate(`/plans/plans-explorer/${areaIndicator.area.plan.planUUID}?selectedAreaId=${encodeURIComponent(areaIndicator.area.areaId)}&selectedAreaIndicatorId=${encodeURIComponent(areaIndicator.areaIndicatorId)}`);
    }

    return (
        <Paper elevation={0} className='AreaIndicatorItemList-container'>
            <div className='AreaIndicatorItemList-title' onClick={handleClickOnName}>
                {areaIndicator.areaIndicatorName}
            </div>
            <IndicatorImpact frameworkSuite={'generic'} frameworkId={2} indicator={areaIndicator.indicatorDTO} className={'AreaIndicatorItemList-impact'} />
        </Paper>
    );
};

export default AreaIndicatorItemList;